<template>
  <DBox
    :id="'cmp-contacts-contacts-contact_info'"
    class="contact-info"
    :addButton="false"
  >
    <TextField2
      v-if="isCompany"
      :id="'company_name'"
      :placeholder="$t('company_name')"
      :label="$t('company_name')"
      :value="contact.contact.company_name"
      @blur="onTextField2ValueChange"
    />
    <TextField2
      v-if="isCompany"
      :id="'company_legalname'"
      :placeholder="$dft.capHead($t('representative'))"
      :label="$dft.capHead($t('representative'))"
      :value="contact.contact.company_legalname"
      @blur="onTextField2ValueChange"
    />
    <TextField2
      v-if="!isCompany"
      :id="'first_name'"
      :value="contact.contact.first_name"
      :placeholder="$t('first_name')"
      :label="$t('first_name')"
      @blur="onTextField2ValueChange"
    />
    <TextField2
      v-if="!isCompany"
      :id="'last_name'"
      :value="contact.contact.last_name"
      :placeholder="$t('last_name')"
      :label="$t('last_name')"
      @blur="onTextField2ValueChange"
    />
    <TextField2
      v-if="!isCompany"
      :id="'nick_name'"
      :value="contact.contact.nick_name"
      :placeholder="$t('nick_name')"
      :label="$t('nick_name')"
      @blur="onTextField2ValueChange"
    />
    <TextField2
      :id="'address1'"
      :value="contact.contact.address1"
      :placeholder="$t('address1')"
      :label="$t('address1')"
      @blur="onTextField2ValueChange"
    />
    <TextField2
      :id="'address2'"
      :value="contact.contact.address2"
      :placeholder="$t('address2')"
      :label="$t('address2')"
      @blur="onTextField2ValueChange"
    />
    <TextField2
      :id="'city'"
      :value="contact.contact.city"
      :placeholder="$t('city')"
      :label="$t('city')"
      @blur="onTextField2ValueChange"
    />
    <TextField2
      :id="'postalcode'"
      :value="contact.contact.postalcode"
      :placeholder="$t('postalcode')"
      :label="$t('postalcode')"
      @blur="onTextField2ValueChange"
    />
    <TextField2
      :id="'region'"
      :value="contact.contact.region"
      :placeholder="$t('region')"
      :label="$t('region')"
      @blur="onTextField2ValueChange"
    />
    <Dropdown2
      :label="$t('country')"
      :placeholder="'Select ' + $t('country')"
      :options="countriesTV"
      :selected="countriesTV.find(c => c.value == contact.contact.country)"
      v-on:selectedChange="e => onDropdownChange('country', e)"
    />
    <Dropdown2
      :label="$t('language')"
      :placeholder="$t('language')"
      :options="languagesTV"
      :selected="languagesTV.find(e => e.value == contact.contact.language)"
      v-on:selectedChange="e => onDropdownChange('language', e)"
    />
    <!-- <div style="display: flex; border-bottom: 1px solid var(--sprt-85)"> -->
    <div style="display: flex;">
      <TextField2
        id="vat_no"
        :label="$t('vat_id')"
        :value="contact.contact.vat_no"
        :bb="'0px'"
        :cw="
          `clamp(48px, ${(
            (contact.contact && contact.contact.vat_no) ||
            ''
          ).toString().length * 13}px, 140px)`
        "
        @blur="onTextField2ValueChange"
        :style="{
          '--fc2-tf-margin-focus': '-1px 3px -1px 0px'
        }"
      />
      <div class="fcc" v-if="Object.keys(accountingInfo) != 0">
        <div class="loading-icon" v-if="vatIdValidityLoading">
          <img src="static/icons/loading.gif" alt />
        </div>
        <div
          v-if="!vatIdValidityLoading"
          :class="`status-button ${this.vatIdValidity ? 'valid' : 'invalid'}`"
          @click="onVatValButtonClick"
        >
          {{ this.vatIdValidity ? $t('valid') : $t('invalid') }}
        </div>
      </div>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import TextField from "@plugins/text-field/text-field";
import Dropdown from "@plugins/dropdown/dropdown";

import { EventHooks } from "../../../../plugins/text-field";
import { createCountriesTV } from "../../../../models/country.model";
import { createLanguageTV } from "../../../../models/language.model";
import { checkVATNumber } from "../../models/vat.model";

export default {
  components: {
    DBox,
    TextField,
    Dropdown
  },
  props: {
    contact: {
      type: Object,
      required: true
    },
    accountingInfo: {
      type: Object
    },
    vatIdValidity: { type: Boolean },
    vatIdValidityLoading: { type: Boolean }
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur
      }
    };
  },
  computed: {
    countriesTV: function() {
      return createCountriesTV(this.contact.countries);
    },
    languagesTV: function() {
      return createLanguageTV((this.contact.languages || []));
    },
    isCompany: function() {
      return this.contact.contact.company_name;
    }
  },
  methods: {
    onTextFieldValueChange: function(name, value) {
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function(name, value) {
      this.$emit("changed", { name, value: value.value });
    },
    onTextField2ValueChange: function(event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onVatValButtonClick: function() {
      checkVATNumber(this.contact.contact.vat_no || "");
    }
  }
};
</script>

<style lang="scss" scoped>
.form-group .dt-dropdown {
  margin: 5px 5px !important;
}
</style>
